module.exports = __webpack_public_path__ + "img/character_c.4723f729.svg";